(() => {
  'use strict';

  if (window.AmelieMakeupPromoTrackerV2) return;
  window.AmelieMakeupPromoTrackerV2 = true;

  const MAKEUP_DISCOUNT = 'paga 2 lleva 3 (maquillaje)';
  const nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  let refreshTimer = 0;
  let requestInFlight = null;
  let refreshQueued = false;

  const normalize = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();

  const isCartMutation = (url, method = 'GET') => {
    const path = String(url || '').split('?')[0];
    return method.toUpperCase() !== 'GET' && /\/cart\/(add|change|update|clear)(\.js)?$/i.test(path);
  };

  const discountTitles = (item) =>
    (item.line_level_discount_allocations || []).map((allocation) =>
      normalize(allocation?.discount_application?.title)
    );

  const buildState = (cart) => {
    let makeupCount = 0;
    let makeupComplete = false;

    (cart.items || []).forEach((item) => {
      const quantity = Number(item.quantity || 0);
      const productType = normalize(item.product_type);
      if (productType.includes('maquill')) makeupCount += quantity;
      if (discountTitles(item).some((title) => title.includes(MAKEUP_DISCOUNT))) {
        makeupComplete = true;
      }
    });

    return {
      total: Number(cart.item_count || 0),
      makeupCount,
      makeupComplete,
    };
  };

  const makeupView = (state, tracker) => {
    const makeupUrl = tracker.dataset.makeupUrl;
    if (state.makeupComplete) {
      return {
        progress: 3,
        complete: true,
        message: '¡Listo! El producto de maquillaje de menor valor ya quedó gratis.',
        cta: 'Ver más maquillaje',
        url: makeupUrl,
      };
    }
    if (state.makeupCount === 0) {
      return {
        progress: 0,
        complete: false,
        message: 'Agrega 3 productos de maquillaje y paga solamente 2.',
        cta: 'Ver maquillaje',
        url: makeupUrl,
      };
    }
    if (state.makeupCount === 1) {
      return {
        progress: 1,
        complete: false,
        message: 'Te faltan 2 productos de maquillaje para recibir el de menor valor gratis.',
        cta: 'Elegir maquillaje',
        url: makeupUrl,
      };
    }
    if (state.makeupCount === 2) {
      return {
        progress: 2,
        complete: false,
        message: '¡Te falta solo 1! El producto de menor valor será totalmente gratis.',
        cta: 'Agregar el tercero',
        url: makeupUrl,
      };
    }
    return {
      progress: 3,
      complete: true,
      message: '¡Oferta completada! Shopify descontará automáticamente el de menor valor.',
      cta: 'Seguir comprando',
      url: makeupUrl,
    };
  };

  const updateCard = (card, view) => {
    if (!card) return;
    card.dataset.complete = String(view.complete);
    card.querySelector('[data-amelie-promo-message]').textContent = view.message;
    card.querySelector('[data-amelie-promo-status]').textContent = view.complete
      ? 'Oferta aplicada ✓'
      : `${view.progress} de 3`;

    const cta = card.querySelector('[data-amelie-promo-cta]');
    cta.textContent = view.cta;
    cta.href = view.url;

    card.querySelectorAll('[data-amelie-promo-segment]').forEach((segment, index) => {
      segment.classList.toggle('is-active', index < view.progress);
    });
  };

  const updateTrackers = (state) => {
    document.querySelectorAll('[data-amelie-promo-tracker]').forEach((tracker) => {
      tracker.hidden = state.total === 0;
      if (state.total === 0) return;
      updateCard(
        tracker.querySelector('[data-amelie-promo-card="makeup"]'),
        makeupView(state, tracker)
      );
    });
  };

  const ensureReminder = () => {
    let reminder = document.querySelector('[data-amelie-promo-reminder]');
    if (reminder) return reminder;

    reminder = document.createElement('aside');
    reminder.className = 'amelie-promo-reminder';
    reminder.dataset.ameliePromoReminder = '';
    reminder.hidden = true;
    reminder.setAttribute('aria-live', 'polite');
    reminder.innerHTML = `
      <span class="amelie-promo-reminder__mark" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7Zm0 0h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7Z"/></svg>
      </span>
      <span class="amelie-promo-reminder__content">
        <strong>MAQUILLAJE 3X2</strong>
        <span class="amelie-promo-reminder__rows">
          <a class="amelie-promo-reminder__row" data-amelie-reminder-row="makeup">
            <span class="amelie-promo-reminder__label">Tu beneficio</span>
            <span class="amelie-promo-reminder__message"></span>
            <span class="amelie-promo-reminder__progress" aria-hidden="true">
              <i></i><i></i><i></i>
            </span>
          </a>
        </span>
      </span>
      <a class="amelie-promo-reminder__cart" href="/cart" aria-label="Ver beneficio en el carrito">›</a>
    `;
    document.body.appendChild(reminder);
    return reminder;
  };

  const reminderMessage = (state) => {
    if (state.makeupComplete) return 'Tu maquillaje gratis ya está aplicado ✓';
    if (state.makeupCount === 1) return 'Te faltan 2 maquillajes para recibir 1 gratis';
    if (state.makeupCount === 2) return 'Te falta 1 maquillaje; el menor valor será gratis';
    return 'Agrega 3 productos y paga solamente 2';
  };

  const updateReminder = (state) => {
    const tracker = document.querySelector('[data-amelie-promo-tracker]');
    if (!tracker) return;
    const reminder = ensureReminder();
    const started = state.makeupCount > 0 || state.makeupComplete;
    reminder.hidden = !started;
    if (!started) return;

    const row = reminder.querySelector('[data-amelie-reminder-row="makeup"]');
    const view = makeupView(state, tracker);
    row.href = view.complete ? '/cart' : view.url;
    row.dataset.complete = String(view.complete);
    row.querySelector('.amelie-promo-reminder__message').textContent = reminderMessage(state);
    row.querySelectorAll('.amelie-promo-reminder__progress i').forEach((segment, index) => {
      segment.classList.toggle('is-active', index < view.progress);
    });
  };

  const cartUrl = () => {
    const root = window.Shopify?.routes?.root || window.T4Sroutes?.root_url || '/';
    return `${root.replace(/\/$/, '')}/cart.js`;
  };

  const refresh = async () => {
    window.clearTimeout(refreshTimer);
    if (!nativeFetch) return;
    if (requestInFlight) {
      refreshQueued = true;
      return requestInFlight;
    }

    refreshQueued = false;
    requestInFlight = nativeFetch(cartUrl(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Cart ${response.status}`);
        return response.json();
      })
      .then((cart) => {
        const state = buildState(cart);
        updateTrackers(state);
        updateReminder(state);
      })
      .catch(() => {})
      .finally(() => {
        requestInFlight = null;
        if (refreshQueued) {
          refreshQueued = false;
          scheduleRefresh(40);
        }
      });

    return requestInFlight;
  };

  const scheduleRefresh = (delay = 80) => {
    window.clearTimeout(refreshTimer);
    if (requestInFlight) {
      refreshQueued = true;
      return;
    }
    refreshTimer = window.setTimeout(refresh, delay);
  };

  if (nativeFetch) {
    window.fetch = async (...args) => {
      const request = args[0];
      const options = args[1] || {};
      const url = typeof request === 'string' ? request : request?.url;
      const method = options.method || request?.method || 'GET';
      const response = await nativeFetch(...args);
      if (isCartMutation(url, method)) scheduleRefresh();
      return response;
    };
  }

  if (window.XMLHttpRequest) {
    const NativeXHR = window.XMLHttpRequest;
    const nativeOpen = NativeXHR.prototype.open;
    const nativeSend = NativeXHR.prototype.send;

    NativeXHR.prototype.open = function (method, url, ...rest) {
      this.__amelieCartMutation = isCartMutation(url, method);
      return nativeOpen.call(this, method, url, ...rest);
    };

    NativeXHR.prototype.send = function (...args) {
      if (this.__amelieCartMutation) {
        this.addEventListener('loadend', () => scheduleRefresh(), { once: true });
      }
      return nativeSend.apply(this, args);
    };
  }

  let observerStarted = false;
  const observer = new MutationObserver((mutations) => {
    const trackerAdded = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === 1 &&
          (node.matches?.('[data-amelie-promo-tracker]') ||
            node.querySelector?.('[data-amelie-promo-tracker]'))
      )
    );
    if (trackerAdded) scheduleRefresh(50);
  });

  const init = () => {
    if (!document.body) {
      window.setTimeout(init, 0);
      return;
    }
    if (!observerStarted) {
      observer.observe(document.body, { childList: true, subtree: true });
      observerStarted = true;
    }
    refresh();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
